import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import { useCurrentUser } from '@/hooks';

const GetStartedRedirect = () => {
  const { user, isUserLoading } = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (isUserLoading || !user.id) return;

    // Check if all required fields are filled
    const hasRequiredFields =
      user.firstName &&
      !user.firstName.includes('@') && // Not a placeholder email
      user.lastName &&
      user.profile?.title &&
      user.profile.company &&
      user.profile.experience;

    if (hasRequiredFields) {
      // Skip to the appropriate step based on payment status
      if (user.isPaid || user.isBusinessPaid) {
        navigate('/get-started/onboarding-video', { replace: true });
      } else {
        navigate('/get-started/membership-select', { replace: true });
      }
    } else {
      // Go to about page
      navigate('/get-started/about', { replace: true });
    }
  }, [user, isUserLoading, navigate]);

  // Show loading state while determining redirect
  if (isUserLoading || !user.id) {
    return null;
  }

  // Fallback to about page if something goes wrong
  return <Navigate to="/get-started/about" replace />;
};

export default GetStartedRedirect;
